import React from 'react';

class TituloDeConcesion_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Título de Concesion';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_TITULO_DE_CONCESION_2024_V1.pdf?alt=media&token=8c161f84-415f-41bc-96c2-9c9d931c3376';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default TituloDeConcesion_pdf